/**
 * @class
 * @description Wrapper class that injects our modified dash loader in a dash player instance.
 * @exports Dash
 */
export default class Dash {
    /**
     * Constructs Hls adapter.
     * @param {Object} player Hls player instance.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(player) {
        new (Dash._adapters.getLoaders().LoaderDash)(player);
    }
}
